export default __webpack_public_path__ + "static/media/Logo.db98f310.svg";